import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'cat-ui-score',
  templateUrl: './score.component.html',
  styleUrls: ['./score.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatIconModule]
})
export class ScoreComponent {
  scoreRange = [2, 4, 6, 8, 10];

  private _score: number;

  get score() {
    return this._score;
  }

  @Input() set score(value: number) {
    this._score = Math.round(value);
  }

  isHalfStar(s: number) {
    return s - 1 === this._score;
  }

  isFullStar(s: number) {
    return s <= this._score;
  }
}
